import { Component, Input } from "@angular/core";

@Component({
	selector: "stages-disclaimer-main",
	templateUrl: "./disclaimer-main.component.html",
	styleUrls: ["./disclaimer-main.component.scss"],
})
export class DisclaimerMainComponent {
	@Input()
	hideALittle = false;

	@Input()
	message: string = "no message provided";
}
